<template>
  <div class="supplier">

  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Πληρωμές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>


    <v-data-table
      :headers="headers"
      :items="debits"
      :search="search"
      sort-by="Date"
      sort-desc
      loading: false
      item-key="DocNumber"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showdialog(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
     </template>

    <template v-slot:item.TotalValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.TotalValue) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}
      </td>
    </template>

 <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

                <div class="text-right" v-if="header.value == 'TotalValue'">
                    Σύνολο: {{ $tocurr($sumField(debits, 'TotalValue')) }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>
    

    </v-data-table>
  </v-card>
</template>


  </div>
</template>

<script>

export default {
  data() {
    return {
      balance: {charges: 0, payments: 0},
      expanded: [],
      loading: true,
      search: '',
      supplier: {},
      supplier_id: this.$route.params.id,
      debits: [],
      headers: [
          {
            text: 'Αρ. Πληρωμής',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '10%',
          },
          { text: 'Ημερομηνία', value: 'Date', width: '10%' },
          { text: 'Συνολο', value: 'TotalValue', align: 'end' },
          { text: 'Τύπος', value: 'PaymTerm.Desc', align: 'center' },
          { text: 'Remarks', value: 'Remarks', align: 'center' },
          { text: 'Actions', value: 'actions' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/suppliers/credits/'+this.supplier_id);
        //console.log(response);
        this.supplier = response.data;
        this.debits = this.supplier.Credits;
        this.balance = this.supplier.Balance;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  }

  }
}
</script>
